import script from "./ETabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./ETabs.vue?vue&type=script&lang=ts&setup=true"

import "./ETabs.vue?vue&type=style&index=0&id=706c7d0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706c7d0d"]])

export default __exports__